'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

exports.default = {
	alignment: _propTypes.PropTypes.string,
	className: _propTypes.PropTypes.string,
	direction: _propTypes.PropTypes.string,
	href: _propTypes.PropTypes.string,
	isInTransition: _propTypes.PropTypes.bool,
	isOpen: _propTypes.PropTypes.bool,
	leftAvatar: _propTypes.PropTypes.object,
	positionV: _propTypes.PropTypes.string,
	primaryText: _propTypes.PropTypes.string,
	rightAvatar: _propTypes.PropTypes.object,
	style: _propTypes.PropTypes.object,
	styleText: _propTypes.PropTypes.object,
	tabIndex: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.number]),
	onBlur: _propTypes.PropTypes.func,
	onClick: _propTypes.PropTypes.func,
	onFocus: _propTypes.PropTypes.func,
	onKeyboardFocus: _propTypes.PropTypes.func,
	onKeyDown: _propTypes.PropTypes.func,
	onKeyUp: _propTypes.PropTypes.func,
	onMouseDown: _propTypes.PropTypes.func,
	onMouseEnter: _propTypes.PropTypes.func,
	onMouseLeave: _propTypes.PropTypes.func,
	onMouseUp: _propTypes.PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-speed-dial/dist/components/bubble-list-item/bubble-list-item.prop-types.js
// module id = 4333
// module chunks = 0